export var generateUID = function () {
    var counter = 1;
    var map = new WeakMap();
    var uid = function (item, index) {
        if (typeof item === 'number' ||
            typeof item === 'string') {
            return index ? "idx-" + index : "val-" + item;
        }
        if (!map.has(item)) {
            map.set(item, counter++);
            return uid(item);
        }
        return 'uid' + map.get(item);
    };
    return uid;
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/react-uid/dist/es2015/uid.js
// module id = 240
// module chunks = 0